import React, { useEffect, useState } from 'react';

import Icons from '@/core/components/Icons';

export interface DraggableProps {
  draggableDefaultItems: string[];
  updateConversationTemplateOrder: (newConversationTemplateOrder: string[]) => void;
}

const Draggable: React.FC<DraggableProps> = ({ draggableDefaultItems, updateConversationTemplateOrder }) => {
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [draggableItems, setDraggableItems] = useState<string[]>([]);

  useEffect(() => {
    setDraggableItems(draggableDefaultItems);
  }, [draggableDefaultItems]);

  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (draggableEvent: React.DragEvent<HTMLDivElement>, index: number) => {
    draggableEvent.preventDefault(); // Needed to allow dropping
    if (draggedIndex === index || draggedIndex === null) return;

    const newDraggableItems = [...draggableItems];
    const draggedItem = newDraggableItems[draggedIndex];
    newDraggableItems.splice(draggedIndex, 1);
    newDraggableItems.splice(index, 0, draggedItem);
    setDraggedIndex(index);
    setDraggableItems(newDraggableItems);
  };

  const handleOnDrop = () => {
    setDraggedIndex(null);
    updateConversationTemplateOrder(draggableItems);
  };

  const handleDeleteDraggableItem = (indexToDelete: number) => {
    const draggableItemsCopy = [...draggableItems];
    draggableItemsCopy.splice(indexToDelete, 1);
    setDraggableItems(draggableItemsCopy);
    updateConversationTemplateOrder(draggableItemsCopy);
  };

  return draggableItems.map((draggableItem, index) => (
    <div
      key={`${draggableItem}-${index}`}
      draggable
      onDragStart={() => handleDragStart(index)}
      onDragOver={draggableEvent => handleDragOver(draggableEvent, index)}
      onDrop={handleOnDrop}
      className={`text-white mb-2 cursor-grab border border-content-placeholder p-4 ${index === draggedIndex ? 'shadow-lg' : 'shadow-none'}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex w-full items-center gap-x-2">
          <Icons icon="minus-circle" size="16" onClick={() => handleDeleteDraggableItem(index)} />
          <p className="line-clamp-5">{draggableItem}</p>
        </div>
        <Icons icon="drag-handle" size="16" />
      </div>
    </div>
  ));
};

export default Draggable;
